import api from "@/services/api";
import type { AssociateFacilitiesWithVendorAssessmentPayload } from "@/types/vendorManufacturingFacilityAssociation.types";

const { pimcoreServiceAPI, pimcoreGuestServiceAPI } = api;

/**
 * Pimcore: `PUT …/vendor/manufacturingfacilityinformation/associateFacilitiesWithVendorAssessment`
 * — authenticated: base {@link pimcoreServiceAPI} (`/pimcore-service/api/{version}`).
 * — guest: base {@link pimcoreGuestServiceAPI} (`/pimcore-service/guest/api/{version}`).
 */
const ASSOCIATE_FACILITIES_WITH_VENDOR_ASSESSMENT_PATH =
  "/vendor/manufacturingfacilityinformation/associateFacilitiesWithVendorAssessment";

const VendorManufacturingFacilityAssociationService = {
  /**
   * Sets which manufacturing facility IDs are associated with a vendor assessment (e.g. after removing a site, send the **remaining** facility ids).
   * @returns Response body shape depends on API; typed as `unknown` until contract is fixed in the app.
   */
  associateFacilitiesWithVendorAssessment: async (
    payload: AssociateFacilitiesWithVendorAssessmentPayload
  ): Promise<unknown> => {
    const resp = await pimcoreServiceAPI.put(
      ASSOCIATE_FACILITIES_WITH_VENDOR_ASSESSMENT_PATH,
      payload
    );
    return resp?.data;
  },

  /**
   * Guest vendor form (`/vendor-form`): same payload as {@link associateFacilitiesWithVendorAssessment}, Pimcore guest base URL.
   */
  associateFacilitiesWithVendorAssessmentAsGuest: async (
    payload: AssociateFacilitiesWithVendorAssessmentPayload
  ): Promise<unknown> => {
    const resp = await pimcoreGuestServiceAPI.put(
      ASSOCIATE_FACILITIES_WITH_VENDOR_ASSESSMENT_PATH,
      payload
    );
    return resp?.data;
  },
};

export default VendorManufacturingFacilityAssociationService;
